export default __webpack_public_path__ + "cfda1bd1a10348ccdefab0e7a0df148d.png";